export var ChargesForDamagedMissingItemsIA = function ChargesForDamagedMissingItemsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "nIK7TZ",
        defaultMessage: [{
          "type": 0,
          "value": "Débitos por artigos danificados ou em falta"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "5P7k5e",
        defaultMessage: [{
          "type": 0,
          "value": "Para encomendas feitas com condições de pagamento a 60 dias, quaisquer artigos comunicados serão removidos da fatura original. Para encomendas que já foram cobradas no envio, a Faire fará o reembolso para o cartão registado no valor dos artigos comunicados."
        }]
      }), strictLocalize({
        id: "g05TNU",
        defaultMessage: [{
          "type": 0,
          "value": "Se optar por substituir artigos, será criada uma nova encomenda com estes artigos de substituição. Os artigos de substituição serão cobrados na data de vencimento da nova fatura, assim que a encomenda de substituição for enviada."
        }]
      }), strictLocalize({
        id: "2RyUSl",
        defaultMessage: [{
          "type": 0,
          "value": "Para quaisquer outras questões, contacte-nos."
        }]
      })];
    }
  };
};